/* eslint-disable react/style-prop-object */
import { useContext, useEffect, useState } from "react";
import { popupcontext } from "../../../../context/Popupscontext";
import trans, { isRTL } from "../../../../utils";
import { filtrationcontext } from "../../../../context/Filtercontext";
import Button from "../../../Helpers/Button/Button";
import { DatePicker, Flex, InputNumber, Select } from "antd";
import dayjs from "dayjs";
import ReportWorkforceFilter from "../../ReportPage/ReportSheetsFilter/ReportWorkforceFilter";
import { ServiceType } from "../../../../constants";
import Searchbar from "../../../Helpers/Searchbar/Searchbar";
import ReportColumnSettings from "../../ReportColumns/ReportColumnSettings";

const { RangePicker } = DatePicker;
const { Option } = Select;

export default function ReportWorkforceHead({
	startDate,
	endDate,
	setIsShown,
	isShown,
	filters,
	setFilters,
	onSubmit,
	reportType,
}) {
	const { handleShow } = useContext(popupcontext);
	const { setSearchQuery } = useContext(filtrationcontext);

	const [query, setQuery] = useState("");
	const handleSearch = (e) => {
		setQuery(e.target.value);
		setSearchQuery(e.target.value);
		setFilters((prev) => ({ ...prev, search: e.target.value }));
	};
	const dateFormat = "YYYY-MM-DD HH:mm:ss";

	const selectAfter = (
		<Select
			defaultValue="min"
			style={{ width: 70 }}
			onChange={(value) => {
				setFilters((prev) => ({ ...prev, lateUnit: value }));
			}}
		>
			<Option value="min">{trans("Min")}</Option>
			<Option value="hr">{trans("Hr")}</Option>
		</Select>
	);

	const fieldVisibility = {
		attendanceThreshold: ["attendance"],
		lateThreshold: ["attendance", "dailyAttendance"],
		efficiencyThreshold: ["productivity"],
		serviceType: ["productivity"],
	};

	const shouldShow = (field) => fieldVisibility[field]?.includes(reportType);

	useEffect(() => {
		setFilters((prev) => ({
			...prev,
			attendanceThreshold: prev.attendanceThreshold ?? 100,
			lateThreshold: prev.lateThreshold ?? 0,
			lateUnit: prev.lateUnit ?? "min",
		}));
	}, [setFilters]);

	return (
		<div className="report-sheet-head flex-between mb-3">
			{reportType !== "shelfMovement" && (
				<Searchbar
					style="search search-dark input-group"
					path={`${process.env.PUBLIC_URL}/assets/Search.svg`}
					placeholder={trans("Search")}
					value={query}
					onChange={handleSearch}
				/>
			)}
			<div />
			<Flex vertical={false} gap={10} justify="center" align="center">
				{shouldShow("attendanceThreshold") && (
					<InputNumber
						addonBefore={trans("Attendance Threshold")}
						addonAfter={"%"}
						style={{ width: 270 }}
						onChange={(value) =>
							setFilters({ ...filters, attendanceThreshold: value })
						}
					/>
				)}
				{shouldShow("lateThreshold") && (
					<InputNumber
						addonBefore={trans("Late Threshold")}
						addonAfter={selectAfter}
						style={{ width: 270 }}
						onChange={(value) =>
							setFilters((prev) => ({
								...prev,
								lateThreshold: value,
							}))
						}
					/>
				)}
				{shouldShow("efficiencyThreshold") && (
					<InputNumber
						addonBefore={trans("Efficiency Threshold: ")}
						onChange={(value) =>
							setFilters({ ...filters, efficiencyThreshold: value })
						}
					/>
				)}
				{shouldShow("serviceType") && (
					<Select
						mode="multiple"
						allowClear
						placeholder={trans("Select Service Type")}
						style={{ width: 200 }}
						maxTagCount={"responsive"}
						value={filters.serviceType}
						onChange={(value) => setFilters({ ...filters, serviceType: value })}
					>
						{ServiceType.map((option) => (
							<Select.Option key={option.value} value={option.value}>
								{trans(option.label)}
							</Select.Option>
						))}
					</Select>
				)}

				{reportType === "productExpiration" &&
					(() => {
						const critical = filters.criticalDays ?? 7;
						const warning = filters.warningDays ?? 30;
						const hasError = warning <= critical;
						return (
							<>
								<InputNumber
									addonBefore={trans("Critical Days")}
									value={critical}
									min={1}
									style={{ width: 185 }}
									status={hasError ? "error" : undefined}
									onChange={(v) =>
										setFilters((p) => ({ ...p, criticalDays: v }))
									}
								/>
								<div
									style={{ display: "flex", flexDirection: "column", gap: 2 }}
								>
									<InputNumber
										addonBefore={trans("Warning Days")}
										value={warning}
										min={1}
										style={{ width: 185 }}
										status={hasError ? "error" : undefined}
										onChange={(v) =>
											setFilters((p) => ({ ...p, warningDays: v }))
										}
									/>
									{hasError && (
										<span
											style={{ color: "#ff4d4f", fontSize: 11, paddingLeft: 4 }}
										>
											{trans("Warning Days must be greater than Critical Days")}
										</span>
									)}
								</div>
							</>
						);
					})()}

				{reportType !== "shelfMovement" && (
					<RangePicker
						showTime
						value={
							startDate && endDate
								? [dayjs(startDate, dateFormat), dayjs(endDate, dateFormat)]
								: ""
						}
						placeholder={[trans("Start Date"), trans("End Date")]}
						disabled={true}
						style={{ maxWidth: 300 }}
					/>
				)}
				<Button
					img={!isRTL ? "Filter.svg" : ""}
					img2={isRTL ? "Filter.svg" : ""}
					onClick={() => {
						handleShow("addForm");
						setIsShown(false);
					}}
					type={"default"}
					text={trans("Filter")}
				/>
				<ReportColumnSettings />
			</Flex>

			<ReportWorkforceFilter
				isShown={isShown}
				setIsShown={setIsShown}
				filters={filters}
				setFilters={setFilters}
				reportType={reportType}
				onSubmit={onSubmit}
			/>
		</div>
	);
}
